import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { featureFlagRolloutApiRef } from './api/FeatureFlagRolloutApi';
import { FeatureFlagRolloutClient } from './api/FeatureFlagRolloutClient';
import { rootRouteRef } from './routes';

export const featureFlagRolloutPlugin = createPlugin({
  id: 'feature-flag-rollout',
  apis: [
    createApiFactory({
      api: featureFlagRolloutApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new FeatureFlagRolloutClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const FeatureFlagRolloutPage = featureFlagRolloutPlugin.provide(
  createRoutableExtension({
    name: 'FeatureFlagRolloutPage',
    component: () => import('./components/FeatureFlagRolloutPage').then(m => m.FeatureFlagRolloutPage),
    mountPoint: rootRouteRef,
  }),
);
